import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import RestoreFundSearchAlert from 'buyside/graphql/mutations/RestoreUserFundSearchAlert';

import DeletedSavedFundSearches from 'buyside/components/presentation/UserAccount/SavedSearches/deletedSavedFundSearches';

const DeletedSavedFundSearchesContainer = ({ deletedSearches, removeFromSoftDelete }) => (
  <Mutation mutation={RestoreFundSearchAlert}>
    {mutate => {
      const restoreFundSearchAlert = args => mutate({ variables: args });
      return (
        <DeletedSavedFundSearches
          deletedSearches={deletedSearches}
          handleRestoreSearchAlert={({ id, name, active, display, employerProfileSavedSearch }) => {
            delete deletedSearches[`${id}`];
            removeFromSoftDelete(deletedSearches);
            restoreFundSearchAlert({
              name,
              active,
              display,
              employerProfileSavedSearchId: employerProfileSavedSearch.id
            });
          }}
          removeFromSoftDelete={removeFromSoftDelete}
        />
      );
    }}
  </Mutation>
);

export default DeletedSavedFundSearchesContainer;
